export const KostentraegerKeys = {
  uploads: {
    all: () => ["kostentraeger", "uploads"] as const,
  },
};
